export default "__VITE_ASSET__DsSwqhNl__"